import {Injectable} from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable, OperatorFunction, map as rxMap} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";
import {SearchCriteria, DEFAULT_PAGE_SIZE} from "../models/search-criteria.model";
import {PropertySearchPageDto} from "../dto/property.search.response.dto";

@Injectable({
  providedIn: 'root'
})
export class PropertyService {

  urlPrefix = 'api/property';


  constructor(private backend: BackendService) {}

    getPropertyInitialData(propertyId: number): Observable<any> {
        const url = `${this.urlPrefix}/initial/${propertyId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    /**
     * Método para registrar la propiedad direccion
     * @param propertyData
     */
    createProperty(propertyData: any): Observable<any> {
        return this.backend.post(this.urlPrefix, propertyData).pipe(
            map(response => response.response)
        );
    }

    getPropertyAddress(propertyId: number): Observable<any> {
        const url = `${this.urlPrefix}/address/${propertyId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    updateProperty(propertyId: number, propertyData: any): Observable<any> {
        const url = `${this.urlPrefix}/address/${propertyId}`;
        return this.backend.put(url, propertyData).pipe(
            map(response => response.response)
        );
    }

    getPropertyLocation(id: any): Observable<any> {
        const url = `${this.urlPrefix}/initial/location/${id}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }
    /**
     * Método para registrar la propiedad direccion
     * @param propertyData
     */
    updatePropertyLocation(id: any, propertyData: any): Observable<any> {
        const url = `${this.urlPrefix}/location/${id}`;
        return this.backend.put(url, propertyData).pipe(
            map(response => response.response)
        );
    }

    getPropertyBasic(id: string): Observable<any> {
        const url = `${this.urlPrefix}/basic/${id}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    /**
     * Búsqueda paginada de propiedades.
     * `offset` (row-offset) y `pageSize` viajan como query params; el resto
     * del criterio en el body (contrato `POST /api/property/search`).
     */
    searchProperties(
        criteria: SearchCriteria,
        offset: number = 0,
        pageSize: number = DEFAULT_PAGE_SIZE,
    ): Observable<PropertySearchPageDto> {
        // Endpoint público: la búsqueda/listado es navegable sin sesión.
        const url = `/api/public/property/search?offset=${offset}&pageSize=${pageSize}`;
        return this.backend.post(url, criteria).pipe(
            map((response: ResponseDto) => response.response as unknown as PropertySearchPageDto)
        );
    }

    getProperties(status: string, offset: number, pageSize: number): Observable<any> {
        const url = `${this.urlPrefix}/by/account/${status}?offset=${offset}&pageSize=${pageSize}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    nextStageProperty(propertyId: any): Observable<any> {
        return this.backend.put(`${this.urlPrefix}/next-stage`, propertyId).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    getDetailProperty(propertyId: any): Observable<any> {
        const url = `${this.urlPrefix}/search/${propertyId}`;
        return this.backend.get(url).pipe(
            map((response: ResponseDto) => response.response)
        );
    }

    updatePropertySegment(propertyId: number, segmentId: number) {
        const url = `${this.urlPrefix}/${propertyId}/segment/${segmentId}`;
        return this.backend.put(url, null).pipe(
            map(response => response.response)
        );
    }
    updatePropertyOwnerStatus(propertyId: number): Observable<any> {
        const url = `${this.urlPrefix}/owner`;
        return this.backend.put(url, {id:propertyId}).pipe(
            map(response => response.response)
        );
    }

    /** Concluye el registro: marca la propiedad COMPLETED_PROP / TO_PUBLISH (la hace visible al público). */
    concludeRegistration(propertyId: number): Observable<any> {
        const url = `${this.urlPrefix}/conclude`;
        return this.backend.put(url, {id:propertyId}).pipe(
            map(response => response.response)
        );
    }
}
